import { useForm } from 'react-hook-form';

import { ResumeForm } from '../../../components/common/resume/resume.type';
import {
  UnregisteredFormStep1,
  UnregisteredFormStep2,
  UnregisteredFormStep4,
  UnregisteredFormStep5,
  UnregisteredFormStep6,
  UnregisteredParams,
} from './unregistered-types';

export const STEPS: Record<string, number> = {
  STEP_VERIFY_POLICY: 0,
  STEP_WHEN: 1,
  STEP_SELECT_LOCATION: 2,
  STEP_VEHICLE_PROBLEMS: 3,
  STEP_PASSENGERS: 4,
  STEP_DESTINATION: 5,
  STEP_RESUME: 6,
  STEP_SELECT_CRANE: 7,
  STEP_SUCCESS: 8,
  STEP_IN_OUR_WAY: 9,
  STEP_TRACK_CRANE: 10,
  STEP_PREVIOUS_INTERVENTION: 101,
};

export const INSIGHTS_STEPS: Record<number, string> = {
  [STEPS.STEP_VERIFY_POLICY]: 'validacion-datos',
  [STEPS.STEP_WHEN]: 'cuando-servicio',
  [STEPS.STEP_SELECT_LOCATION]: 'donde-vehiculo',
  [STEPS.STEP_VEHICLE_PROBLEMS]: 'tipo-averia',
  [STEPS.STEP_PASSENGERS]: 'datos-pasajeros',
  [STEPS.STEP_DESTINATION]: 'destino',
  [STEPS.STEP_RESUME]: 'resumen',
  [STEPS.STEP_SELECT_CRANE]: 'seleccion-grua',
  [STEPS.STEP_SUCCESS]: 'exito',
  [STEPS.STEP_IN_OUR_WAY]: 'en-camino',
  [STEPS.STEP_TRACK_CRANE]: 'seguimiento-grua',
  [STEPS.STEP_PREVIOUS_INTERVENTION]: 'intervención-anterior',
};

export const LAST_REFRESH_STEP = STEPS.STEP_TRACK_CRANE;

export const useUnregisteredData = (params: Partial<UnregisteredParams>) => {
  const getDefaultValues = {
    form1: {
      // *** should not commit *** //
      dni: import.meta.env.DEV ? import.meta.env.VITE_DEV_DNI : '',
      plate: import.meta.env.DEV ? import.meta.env.VITE_DEV_PLATE : '',
      phone: import.meta.env.DEV ? import.meta.env.VITE_DEV_PHONE : '',
      // *** should not commit *** //
      name: '',
      surname: '',
      policyCode: '',
      identifier: params.identifier ?? '',
      insuranceCompany: params.entityCode ?? '',
    },
    form2: {
      delayed: false,
      date: new Date(),
      time: new Date(),
    },
    form4: {
      latitude: 0,
      longitude: 0,
      undergroundParking: undefined,
      externalRoad: undefined,
      locationInformation: '',
      search: '',
      locationDescription: '',
    },
    form5: {
      faultType: undefined,
      notStartingReason: undefined,
      tyreChange: undefined,
      affectedTyres: 0,
      faultInformation: '',
      otherFaultInformation: '',
      redBatteryLight: undefined,
      adults: 0,
      minors: 0,
      passengersWithSpecialNeeds: undefined,
      specialNeedsInformation: '',
      outOfHighway: undefined,
      blockedTyres: false,
      generateMediaTask: false,
    },
    form6: {
      selectDestination: 0,
      latitude: 0,
      longitude: 0,
      locationInformation: '',
      search: '',
      locationDescription: '',
      step: 1,
      error: false,
    },
    form7: {
      privPolicy: false,
      cookiesPolicy: false,
    },
  };

  // Init of forms
  const form1 = useForm<UnregisteredFormStep1>({
    defaultValues: getDefaultValues.form1,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form2 = useForm<UnregisteredFormStep2>({
    defaultValues: getDefaultValues.form2,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form4 = useForm<UnregisteredFormStep4>({
    defaultValues: getDefaultValues.form4,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form5 = useForm<UnregisteredFormStep5>({
    defaultValues: getDefaultValues.form5,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form6 = useForm<UnregisteredFormStep6>({
    defaultValues: getDefaultValues.form6,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  const form7 = useForm<ResumeForm>({
    defaultValues: getDefaultValues.form7,
    shouldUnregister: false,
    reValidateMode: 'onChange',
    mode: 'onChange',
    shouldFocusError: true,
  });

  return { getDefaultValues, form1, form2, form4, form5, form6, form7 };
};
